import {route} from '@/router/route-utils'

const prefix = '/admin/notices';

const routes = [

    route(
        prefix, 'admin.notices.list', {
            components : {
                main: () => import('./views/AdminNoticesListView')
            },
            requiresAuth: true,
            layout: 'LayoutFull',
            title: 'Notices',
            breadcrumb: [
                {text: 'Notices', active: true},
            ],
        }
    ),
];

export default routes
